import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CanonicalUrlService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  addCanonicalUrl(url: string) {
    const canonicalUrl = environment.canonicalBaseUrl + url;
    const link = this.document.getElementById('CanonicalUrl');
    if (link) {
      link.setAttribute('href', canonicalUrl);
    } else {
      const newLink = this.document.createElement('link');
      newLink.setAttribute('rel', 'canonical');
      newLink.setAttribute('href', canonicalUrl);
      newLink.id = 'CanonicalUrl';
      this.document.head.appendChild(newLink);
    }
  }
}
